import Pusher from 'pusher-js';

export const PusherInstance = new Pusher(process.env.REACT_APP_PUSHER_KEYS as string, {
  cluster: 'mt1',
});
export const channel1 = PusherInstance.subscribe('profile-request');
export const channel2 = PusherInstance.subscribe('profile-request-count');
